/**
 * "WO coming later" (WO rework slice 7, Corbin's pick 5 = A).
 *
 * A job for a customer that sends work orders can't be dispatched without its
 * work order. The server answers 409 WO_REQUIRED; this shows that in plain
 * words with one button: tick "WO coming later" and try again.
 */
import { toast } from "sonner";

import { api } from "@/lib/api";

export const WO_REQUIRED = "WO_REQUIRED";

export function isWoRequired(code: string | undefined | null): boolean {
    return code === WO_REQUIRED;
}

export function woRequiredToast(jobId: string, message: string | undefined, retry?: () => void): void {
    toast.error(message ?? "This store sends work orders and this job has none.", {
        action: {
            label: "WO coming later",
            onClick: () => {
                api.post(`/api/jobs/${jobId}/wo-coming-later`, { on: true })
                    .then(() => {
                        if (retry) {
                            toast.success("Marked: work order coming later.");
                            retry();
                        } else {
                            toast.success("Marked: work order coming later. Try again.");
                        }
                    })
                    .catch(() => toast.error("Couldn't mark it. Try again."));
            },
        },
    });
}
